export default {
    fetchJSON(url) {
      return fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }
          return response.json()
        })
        .catch(error => {
          console.error('Error fetching data:', error)
          return null
        })
    }
  }
  